import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  root: {
    padding: theme.spacing(3, 4),
    border: `1px solid ${theme.palette.dividerV2.main}`,
    width: '100%',
    borderRadius: '4px',
    boxSizing: 'border-box',
  },
  elementsGap: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
  },
  titleWraper: {
    display: 'flex',
    gap: theme.spacing(4),
  },
  sectionText: {
    fontSize: '14px !important',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px !important',
    letterSpacing: '0.25px',
    color: theme.palette.labraText.description,
    fontFamily: theme.typography.fontFamily,
    textAlign: 'left',
  },
  border: {
    borderBottom: `1px solid ${theme.palette.dividerV2.main}`,
    width: '100%',
    borderRadius: '4px',
    boxSizing: 'border-box',
  },
  resourceRow: {
    display: 'flex',
    justifyContent: 'flex-start',
    gap: theme.spacing(4),
    width: '100%',
  },
  resourcesContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    gap: theme.spacing(4),
    width: '100%',
  },
  alignDescription: {
    display: 'flex',
    alignItems: 'center',
    height: '100%',
    color: theme.palette.textField.dark,
    fontFamily: theme.typography.fontFamily,
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
  },
  value: {
    color: theme.palette.labraText.description,
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '20px',
    paddingBottom: theme.spacing(2),
  },
  dimensionsHeadingName: {
    width: '42%',
    height: '32px',
  },
}))
